export default __webpack_public_path__ + "static/media/Screenshot_7.aa0ea28e.png";